module.exports = __webpack_public_path__ + "static/media/Tonya Custis.fa19d067.png";